import { render, staticRenderFns } from "./user-state.vue?vue&type=template&id=018f1ed0&scoped=true"
import script from "./user-state.vue?vue&type=script&lang=js"
export * from "./user-state.vue?vue&type=script&lang=js"
import style0 from "./user-state.vue?vue&type=style&index=0&id=018f1ed0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018f1ed0",
  null
  
)

export default component.exports